import generateDirective from '../generator';
import BankAccountStageController from './controller';

generateDirective('BankAccount', '/customer_application_renderer/stages/bank_account/form.html', BankAccountStageController);
